export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6543.c1c5bec1.jpg";